import * as Content from '../reducers/Content'

export function selectedContent(state) {
  const { selectedContentId } = state.app
  if (selectedContentId === undefined) {
    return null
  }
  const boards = {
    ...state.ownContentCollection,
    ...state.receivedContentCollection,
  }
  return boards[selectedContentId] ?? null
}

export function selectedNode(state) {
  const content = selectedContent(state)
  if (content === null) {
    return null
  }
  if (state.app.selectedNodeId === undefined) {
    return content
  }
  return Content.nodeWithId(content, state.app.selectedNodeId)
}

export function selectedContentNode(state) {
  const node = selectedNode(state)
  if (node === null) {
    return null
  }
  return Content.isFolderNode(node) ? null : node
}

export function selectedFolder(state) {
  const content = selectedContent(state)
  if (content === null) {
    return null
  }
  if (state.app.selectedNodeId === undefined) {
    return content
  }
  const node = Content.nodeWithId(content, state.app.selectedNodeId)
  if (node === null) {
    return node
  }
  if (Content.isFolderNode(node)) {
    return node
  }
  return Content.parentOfId(content, node.id)
}

export function selectBoards(state) {
  const userOrder = state.app.content?.order || []
  const boards = {
    ...state.ownContentCollection,
    ...state.receivedContentCollection,
  }

  const order = userOrder
    .concat(Object.keys(boards).filter((item) => userOrder.indexOf(item) < 0))
    .filter((contentId) => {
      return Object.keys(boards).includes(contentId)
    })

  return {
    boards,
    order,
  }
}
